import PropTypes from 'prop-types';

export const fileDataShape = PropTypes.shape({
  addedBy: PropTypes.string,
  date: PropTypes.string,
  fileName: PropTypes.string,
});
